import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getPayments = createAsyncThunk(
    "orders/getPayments",
    async ({ token, offset = 1, limit = 15 }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/payments/list`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        offset: offset,
                        limit: limit
                    }
                }
            );
            if (response.data.status) {
                return { offset, response: response.data.response.items };
            } else {
                return rejectWithValue("Failed to fetch ");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || "Unknown error");
        }
    }
);

const paymentSlice = createSlice({
    name: "payments",
    initialState: {
        paymentsData: [],
        isLoading: false,
        isError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPayments.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(getPayments.fulfilled, (state, action) => {
                state.isLoading = false;

                if (action.payload.offset === 1) {
                    state.paymentsData = action.payload.response

                } else {
                    state.paymentsData = [...state.paymentsData, ...action.payload.response]

                }

            })
            .addCase(getPayments.rejected, (state, action) => {
                state.isLoading = false;


            })
    },
});

export default paymentSlice.reducer;
